// src/components/dev/BfCacheProbe.client.tsx
'use client'
import { useEffect } from 'react'

export default function BfCacheProbe() {
  useEffect(() => {
    const onPageShow = (e: PageTransitionEvent) => {
      if (e.persisted) console.info('[BFCache] Restored from BFCache')
    }
    window.addEventListener('pageshow', onPageShow)

    // Attempt to print notRestoredReasons (Chrome-only; safe if missing)
    const nav = performance.getEntriesByType('navigation')[0] as any
    if (nav?.notRestoredReasons?.length) {
      console.info('[BFCache] Not restored reasons:', nav.notRestoredReasons)
    }
    return () => window.removeEventListener('pageshow', onPageShow)
  }, [])
  return null
}